
import { AuthUser } from '@/types/auth';

/**
 * Check if user has specific role
 */
export const hasRole = (user: AuthUser | null, role: string): boolean => {
  console.log("hasRole check called with:", { 
    userId: user?.id,
    checkingForRole: role, 
    userHasRolesArray: user && 'roles' in user,
    userRoles: user?.roles
  });
  
  if (!user) {
    console.log("hasRole check failed: no user available");
    return false;
  }
  
  if (!user.roles || !Array.isArray(user.roles) || user.roles.length === 0) {
    console.log("hasRole check failed: user has no roles array or empty roles", { user });
    return false;
  }
  
  const hasTheRole = user.roles.includes(role);
  console.log(`Checking if user has role '${role}':`, hasTheRole, "Available roles:", user.roles);
  
  return hasTheRole;
};
